import i18n from '@/i18n/locale'
import { sprintf } from 'sprintf-js';
// 规则展示非常复杂 具体参考 soda-act src/page/c/xtc/detailRules.vue

const jp_brand_txt = i18n.t('productname_didi_food')
const TELNUM = {
  MX: '8008016888',
  BR: '03003130099',
  JP: '0120132355',
  CR: '50641063372',
  CO: '5715801398',
  DO: '(+) 18 29956 8643'
}
// 客服邮箱
const EMAIL = {
  MX: 'soporte.food@mx.didiglobal.com',
  BR: '', // 巴西暂时没有邮箱配置
  JP: 'customer@didifood.co.jp',
  CR: '',
  CO: 'didifood.co@didiglocal.com',
  DO: 'didifood.do@didiglocal.com'
}
const ruleMap = {
  1: i18n.t('活动时间' /* R1 */),
  2: sprintf(i18n.t('邀请好友成为%s新用户，好友领取您送出的红包，并在活动时间截止前完成订单且无退款，无论是否使用领取的红包下单，您均可获得%s[优惠券]奖励' /* R2 */), jp_brand_txt, jp_brand_txt),
  3: i18n.t('奖励会在邀请成功后的48小时内发放入您的账号，您可在%s-钱包-券中查看' /* R3 */),
  4: i18n.t('您邀请的好友必须是%s新用户，每人仅限享受1次新用户首单优惠，同一手机号、同一设备、同一支付账号视为同一用户' /* R4 */),
  5: i18n.t('您邀请的好友需通过%s下单，通过其他渠道下单不发放邀请奖励' /* R5 */),
  6: i18n.t('优惠券使用门槛及有效期详见券面提示，未在券有效期限内使用完毕的，不可继续使用' /* R6 */),
  7: i18n.t('本优惠活动仅限[%s]开通%s区域' /* R7 */),
  8: i18n.t('本优惠活动仅限%s[在线支付]的订单享受，不可提现转赠' /* R8 */),
  9: i18n.t('单笔订单金额满足优惠券使用门槛金额时方可使用，单笔订单只能使用一张优惠券，使用优惠后，如订单金额超出部分需用户自行支付' /* R9 */),
  10: i18n.t('一经发现任何违规、套现行为，将追回相关金额或者封停账号，且依法追究其法律责任' /* R10 */),
  11: i18n.t('收餐人手机号与领取券时输入的手机号和账号注册手机号必须为同一号码' /* R11 */),
  12: i18n.t('关于本活动的任何问题，请联系%s客服' /* R12 */),
  13: i18n.t('FoodC_page_Rewards_are_dWeY'), /* R13 */
  14: i18n.t('FoodC_page_Invite_friends_oGuj', {productname_didi_food: jp_brand_txt}), /* R14 只有日语和英语 对应R2的UIkey */
  15: i18n.t('FoodC_page_Rewards_will_NhMd', {productname_didi_food: jp_brand_txt}), /* R15 只有日语和英语 对应R3的UIkey */
  16: i18n.t('FoodC_page_Your_invited_sPpR', {productname_didi_food: jp_brand_txt}), /* R16 只有日语和英语 对应R4的UIkey */
  17: i18n.t('FoodC_page_The_threshold_yZFq'), /* R17 只有日语和英语 对应R6的UIkey */
  18: i18n.t('FoodC_page_This_special_fYuo', {activity_city: '', productname_didi_food: jp_brand_txt}), /* R18 只有日语和英语 对应R7的UIkey */
  19: i18n.t('FoodC_page_Upon_discovery_baTq'), /* R19 只有日语和英语 对应R10的UIkey */
  20: i18n.t('FoodC_page_For_any_IWNZ', {contact_email: EMAIL['JP']}), /* R20 只有日语和英语 对应R12的UIkey */
  21: i18n.t('FoodC_rule_14_Up_dovx'), /* R21 每个用户每天最多用券2张 */
}
const ruleCountryList = {
  'JP': [
    ruleMap[13],
    ruleMap[14],
    ruleMap[15],
    ruleMap[16],
    ruleMap[17],
    ruleMap[18],
    ruleMap[19],
    ruleMap[20],
  ]
}
export {
  ruleMap,
  ruleCountryList
}